import { OPEN, CLOSE } from '../actions/chatbotActions'

/**
 * Components Reducer
 * @module  {Reducer} chatbotReduced
 *
 * @param {Object} state      The current state
 * @param {Object} action     The action
 * @return {Object}           The new state
 */
export default (state = { open: false }, action) => {
  switch (action.type) {
    case OPEN:
      return { ...state, open: true }
    case CLOSE:
      return { ...state, open: false }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./state/reducers/chatbotReducer.js